<template>
 <v-container fluid grid-list-md>
      <v-row no-gutters class="pa-0">
        <v-col cols="12" xl="6" lg="6" xs="6" sm="6" md="6">
          <h1>{{this.$store.state.documentActivLoc}}</h1>
        </v-col>
        <v-col cols="12" xl="6" lg="6" xs="6" sm="6" md="6">
          <div class="text-right">
              <v-btn fab dark class="indigo" @click="newpartner">
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
          </div>
        </v-col>
      </v-row>
      <app-Partner-list></app-Partner-list>
    </v-container>
</template>

<script>
import Partnerlist from './PartnerList'
export default {
  name: 'partner',
  data () {
    return {
      msg: '',
      privateP: true
    }
  },
  mounted () {
    this.privateP = this.$store.state.user ? this.$store.state.user.privatePartner : true
  },
  methods: {
    async newpartner () {
      try {
        if (this.privateP) {
          await this.$router.push({
            name: 'partnercreate2'
          })
        } else {
          await this.$router.push({
            name: 'partnercreate'
          })
        }
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    }
  },
  computed: {

  },
  watch: {

  },
  components: {
    appPartnerList: Partnerlist
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
